import {isDevXd} from "../../ui-components/debug/is-dev";

export const ConfigDefaultAssetManager = async ({ccEditor, userData, ccConfig, assetSources}) => {
    const product = await ccEditor.getProduct();
    // adjust allowed tabs for built-in asset manager
    try {

        //if headshots/logos are disabled for the user, remove the image gallery to prevent image uploads
        let userLevel = userData.sourceData.xd.userLevel ? userData.sourceData.xd.userLevel.userLevel : 0;
        let canEditHeadshot = userLevel <= 3 || (userLevel === 5 && userData.sourceData.xd.company.prefs.agentCanEditHeadshot === 1) || (userLevel === 4 && userData.sourceData.xd.company.prefs.officeCanEditHeadshot1 === 1);
        let canEditLogos = userLevel <= 3 || (userLevel === 5 && userData.sourceData.xd.company.prefs.agentCanEditLogos === 1) || (userLevel === 4 && userData.sourceData.xd.company.prefs.officeCanEditLogos === 1);
        let itemList = [];

        // any arguments used in this function must be added to the list at the end or this will break.
        await product.getItems((item, args) => {

            let change = false;
            if(!args.canEditHeadshot || !args.canEditLogos) {
                let surface = item.parentContainer.parentComponent.name ? item.parentContainer.parentComponent.name : '';
                let imageTag = args.tempBinding[surface] && args.tempBinding[surface][item.name] ? args.tempBinding[surface][item.name].imageTag : '';
                if( item.allowedTabs && ((!args.canEditHeadshot && imageTag === "headshot1") || (!args.canEditLogos && imageTag === "logo")) ) {
                    for(let i = item.allowedTabs.length - 1; i >= 0; i--) {
                        if( item.allowedTabs[i] === "Image Gallery" ) {
                            item.allowedTabs.splice(i, 1);
                        }
                    }
                    change = true;
                }
            }
            if( item.allowedTabs && item.allowedTabs.includes("Image Gallery")){
                if(item.allowedTabs.includes("Headshot Gallery")){
                    item.allowedTabs.push("Headshot Upload Gallery");
                    if( !args.assetSources?.["Headshot Gallery"]?.rootCategory?.assets?.length ) {
                        for(let i = item.allowedTabs.length - 1; i >= 0; i--) {
                            if( item.allowedTabs[i] === "Headshot Gallery" ) {
                                item.allowedTabs.splice(i, 1);
                            }
                        }
                    }
                    change = true;
                }
                if(item.allowedTabs.includes("Agent Logo Gallery")){
                    item.allowedTabs.push("Logo Upload Gallery");
                    if( !args.assetSources?.["Agent Logo Gallery"]?.rootCategory?.assets?.length ) {
                        for(let i = item.allowedTabs.length - 1; i >= 0; i--) {
                            if( item.allowedTabs[i] === "Agent Logo Gallery" ) {
                                item.allowedTabs.splice(i, 1);
                            }
                        }
                    }
                    change = true;
                }
                if(item.allowedTabs.includes("Property Photos")){
                    item.allowedTabs.push("Property Upload Gallery");
                    if( !args.assetSources?.["Property Photos"]?.rootCategory?.assets.length ) {
                        for(let i = item.allowedTabs.length - 1; i >= 0; i--) {
                            if( item.allowedTabs[i] === "Property Photos" ) {
                                item.allowedTabs.splice(i, 1);
                            }
                        }
                    }
                    change = true;
                }
                if(change){
                    for(let i = item.allowedTabs.length - 1; i >= 0; i--) {
                        if( item.allowedTabs[i] === "Image Gallery" ) {
                            item.allowedTabs.splice(i, 1);
                        }
                    }
                }
            }
            if(change){
                args.itemList.push(item);
            }
        }, {itemList: itemList, tempBinding: ccConfig['templateBindingData'], canEditHeadshot: canEditHeadshot, canEditLogos: canEditLogos, assetSources});
        itemList.forEach(async item => {
            try {
                if (isDevXd()) console.log("CcEditor.loadCanvas getItems Item", item);

                await product.setItem(item);

            }
            catch(e){console.log(e)}
        });
    }catch(e){
        isDevXd() ? console.log("Gallery set up error", e) : null;
    }
}
;